/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum MyChartAllergieDetailAliases {
  ACTION_DELETE = 'action-delete',
  ACTION_SUBMIT = 'action-submit',
  AUTOCOMPLETE_ALLERGIE = 'autocomplete-allergie',
  AUTOCOMPLETE_REACTION_TYPE = 'autocomplete-reaction-type',
  BREADCRUMB_ALLERGIES = 'breadcrumb-allergies',
  CONTEXTUAL_BAR_ALLERGIE_DETAIL = 'contextual-bar-allergie-detail',
  DATE_FIELD_END = 'date-field-end',
  DATE_FIELD_START = 'date-field-start',
  FETCH_ALLERGIES = 'fetch-allergies',
  FETCH_REACTION_TYPE = 'fetch-reaction-type',
  FIELD_ALLERGIE = 'field-allergie',
  FIELD_ALLERGIE_NOT_REGISTERED = 'field-allergie-not-registered',
  FIELD_CLASSIFICATION = 'field-classification',
  FIELD_INTENSITY = 'field-intensity',
  FIELD_LAST_DATE = 'field-last-date',
  FIELD_OBSERVATION = 'field-observation',
  FIELD_REACTION_NOT_REGISTERED = 'field-reaction-not-registered',
  FIELD_REACTION_TYPE = 'field-reaction-type',
  FIELD_START_DATE = 'field-start-date',
  FORM_ALLERGIE = 'form-allergie',
  INPUT_ALLERGIE_NOT_REGISTERED = 'input-allergie-not-registered',
  INPUT_REACTION_NOT_REGISTERED = 'input-reaction-not-registered',
  LAYOUT_ALLERGIE_DETAIL = 'layout-allergie-detail',
  MAPPER_ALLERGIE_TYPE = 'mapper-allergie-type',
  MAPPER_REACTION_TYPE = 'mapper-reaction-type',
  PANEL_ALLERGIES = 'panel-allergies',
  RADIO_CATEGORY = 'radio-category',
  RADIO_INTENSITY = 'radio-intensity',
  TEXT_ALLERGIE_TYPE = 'text-allergie-type',
  TEXT_AREA_OBSERVATION = 'text-area-observation',
  TEXT_REACTION_TYPE = 'text-reaction-type',
}
export { MyChartAllergieDetailAliases };
